import { useEffect, useState } from "react";
import { Button, Box, Typography, Paper } from "@mui/material";
import CreateUserModal from "../components/Modal/CreateUserModal";
import ModalComponent from "../components/Modal/Modal";
import ErrorMessage from "../components/ErrorMessage";
import { useStore } from "../store/useStore";
import { useAuthStore } from "../store/useAuthStore";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes/routes";
import googleIcon from "../assets/google.svg";
import microsoftIcon from "../assets/microsoft.svg";
import yahooIcon from "../assets/yahoo.svg";

export const BANNER_COLOR = "#ffee00"; // Color amarillo
export const BANNER_COLOR_LIGHT = "#FCF072"; // Color amarillo claro
export const TEXT_COLOR = "black"; // Color negro
export const BUTTONS_COLOR = "default"; // negro
export const HOVER_COLOR = "#FAEF5C"; // Color amarillo sombreado

const PROVIDER_LABELS = {
  google: "Google",
  outlook: "Outlook",
  yahoo: "Yahoo",
};

function Root() {
  const [openModal, setOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [isChecking, setIsChecking] = useState(false);

  const setTimerVisible = useStore((state) => state.setTimerVisible);
  const resetStopwatchValue = useStore((state) => state.resetStopwatchValue);

  // Autenticación
  const startLogin = useAuthStore((s) => s.startLogin);
  const session = useAuthStore((s) => s.session);
  const isSignedIn = !!session?.authenticationToken;

  const navigate = useNavigate();

  useEffect(() => {
    // Si no hay sesión, oculta el timer y resetea cronómetro
    if (!isSignedIn) {
      setTimerVisible(false);
      resetStopwatchValue();
    } else {
      navigate(routes.home, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn]);

  const handleProviderClick = async (provider) => {
    try {
      setIsChecking(true);
      await startLogin(provider);
    } catch (e) {
      setErrorMessage(`No se pudo iniciar sesión con ${PROVIDER_LABELS[provider]}. Inténtelo de nuevo.`);
      setIsErrorModal(true);
    } finally {
      setIsChecking(false);
    }
  };

  const handleCloseModal = () => setOpenModal(false);
  const closeErrorModal = () => {
    setIsErrorModal(false);
    setErrorMessage("");
  };

  return (
    <div className="w-full justify-center items-center h-full flex flex-col">
      <div className="flex flex-col justify-center items-center gap-4 mt-40">
        <img className="h-20" src={`${process.env.PUBLIC_URL}/favicon.png`} alt="Escudo de Colombia" />
        <h1>Aplicación de cuestionarios del CEV</h1>
      </div>

      <Box
        sx={{
          mt: 8,
          width: "100%",
          maxWidth: 380,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 3,
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography variant="subtitle2" align="center" sx={{ mb: 2, color: "text.secondary" }}>
            Iniciar sesión con
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {/* Microsoft */}
            <Button
              fullWidth
              variant="contained"
              disabled={isChecking}
              onClick={() => handleProviderClick("outlook")}
              startIcon={<img src={microsoftIcon} alt="Google" style={{ width: 20, height: 20 }} />}
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                borderRadius: 999,
                backgroundColor: "#FCFCFC",
                boxShadow: "none",
                border: "1px solid #dadce0",
                "&:hover": {
                  backgroundColor: "#F5F5F5",
                  boxShadow: "none",
                },
              }}
            >
              Outlook (Uniandes)
            </Button>

            {/* Google */}
            <Button
              fullWidth
              variant="contained"
              disabled={isChecking}
              onClick={() => handleProviderClick("google")}
              startIcon={<img src={googleIcon} alt="Google" style={{ width: 20, height: 20 }} />}
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                borderRadius: 999,
                backgroundColor: "#FCFCFC",
                boxShadow: "none",
                border: "1px solid #dadce0",
                "&:hover": {
                  backgroundColor: "#F5F5F5",
                  boxShadow: "none",
                },
              }}
            >
              Google
            </Button>

            {/* Yahoo */}
            <Button
              fullWidth
              variant="contained"
              disabled={isChecking}
              onClick={() => handleProviderClick("yahoo")}
              startIcon={<img src={yahooIcon} alt="Google" style={{ width: 20, height: 20 }} />}
              sx={{
                justifyContent: "flex-start",
                textTransform: "none",
                borderRadius: 999,
                backgroundColor: "#FCFCFC",
                boxShadow: "none",
                border: "1px solid #dadce0",
                "&:hover": {
                  backgroundColor: "#F5F5F5",
                  boxShadow: "none",
                },
              }}
            >
              Yahoo
            </Button>
          </Box>
        </Paper>
        {/* Boton escondido temporalmente */}
        {/* <Button variant="contained" onClick={() => setOpenModal(true)}>
          Registrarse
        </Button> */}
      </Box>
      {/* ACTUALMENTE NO SE ESTÁ UTILIZANDO, SE UTILIZA CUANDO EL USUARIO NECESITE GESTIONAR SU PROPIO REGISTRO*/}
      {/* <CreateUserModal openModal={openModal} onClose={handleCloseModal} setOpenModal={setOpenModal} setShowSignIn={setShowSignIn} /> */}

      {errorMessage && (
        <ModalComponent open={isErrorModal} handleClose={closeErrorModal} width={"30%"}>
          <ErrorMessage>
            <div className="flex flex-col gap-2 ">
              <div>{errorMessage}</div>
              {/* {showRegisterButton && (
                <Button
                  variant="contained"
                  onClick={() => {
                    setOpenModal(true);
                    setErrorMessage("");
                  }}
                >
                  Registrarse
                </Button>
              )} */}
            </div>
          </ErrorMessage>
        </ModalComponent>
      )}
    </div>
  );
}

export default Root;
